module.exports = __webpack_public_path__ + "8853f20f0264aae52b9272e28904b74a.pdf";